import { Col, Row } from 'react-bootstrap';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { RESULTS_PER_PAGE } from '../config';
import { ResultsPerPageSelect } from '../form';
import { setCurrentPage, useFormContext } from '../state/form';
import { useSettingsContext } from '../state/settings';
import { SettingsButton } from './SettingsButton';
import { DownloadButton } from './DownloadButton';
import { PermalinkButton } from './PermalinkButton';
import { ResultListTable } from './ResultListTable';
import { SmallPagination } from '../form/SmallPagination';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function BlockResultTabList() {
  var _useFormContext = useFormContext(),
      _useFormContext$state = _useFormContext.state,
      data = _useFormContext$state.data,
      form = _useFormContext$state.form,
      loading = _useFormContext$state.loading,
      dispatchForm = _useFormContext.dispatch;

  var _useSettingsContext = useSettingsContext(),
      _useSettingsContext$s = _useSettingsContext.state.data,
      matchesHighlighting = _useSettingsContext$s.matchesHighlighting,
      wikipediaLinks = _useSettingsContext$s.wikipediaLinks,
      columnEventType = _useSettingsContext$s.columnEventType,
      columnActCode = _useSettingsContext$s.columnActCode;

  var setCurrentPageDispatch = function setCurrentPageDispatch(currentPage) {
    return dispatchForm(setCurrentPage(currentPage));
  };

  var handlePageChange = function handlePageChange(newPage) {
    setCurrentPageDispatch(newPage);
    window.scrollTo({
      // TODO increase the speed of the animation (too slow!)
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  };

  var renderCounts = function renderCounts(className) {
    return /*#__PURE__*/_jsxs("span", {
      className: (loading ? 'group-disabled' : '') + ' ' + className,
      children: [/*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "result.n_results",
          values: {
            results: /*#__PURE__*/_jsx(FormattedNumber, {
              value: data.count
            }),
            n: data.count
          }
        })
      }), ' ', "\xB7", ' ', /*#__PURE__*/_jsx(FormattedMessage, {
        id: "result.page_of",
        values: {
          current: /*#__PURE__*/_jsx(FormattedNumber, {
            value: form.currentPage
          }),
          total: /*#__PURE__*/_jsx(FormattedNumber, {
            value: Math.max(totalPages, 1)
          })
        }
      }), ' ', /*#__PURE__*/_jsxs("span", {
        className: "d-none d-md-inline",
        children: ["\xB7", ' ', /*#__PURE__*/_jsx(FormattedMessage, {
          id: "result.results_per_page"
        }), ' ']
      })]
    });
  };

  var totalPages = Math.ceil(data.count / form.resultsPerPage);
  return /*#__PURE__*/_jsxs("div", {
    className: "block block-tab block-tab-results pb-1 pt-2",
    children: [/*#__PURE__*/_jsxs(Row, {
      className: "px-2",
      children: [/*#__PURE__*/_jsxs(Col, {
        xs: 6,
        sm: 3,
        md: 2,
        className: "pr-0",
        children: [/*#__PURE__*/_jsx(PermalinkButton, {
          disabled: loading,
          className: "mr-2"
        }), /*#__PURE__*/_jsx(DownloadButton, {
          disabled: loading || data.count === 0
        })]
      }), /*#__PURE__*/_jsxs(Col, {
        xs: 6,
        sm: 9,
        md: 10,
        className: "text-right pl-0",
        children: [renderCounts('d-none d-sm-inline'), /*#__PURE__*/_jsx(ResultsPerPageSelect, {
          values: RESULTS_PER_PAGE,
          disabled: loading
        }), /*#__PURE__*/_jsx(SettingsButton, {
          className: "ml-2"
        })]
      })]
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        className: "px-4 mt-2 m-sm-0 text-right",
        children: renderCounts('d-sm-none')
      })
    }), data.count > 0 ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ResultListTable, {
        results: data.results,
        formData: form,
        disabled: loading,
        withHighlights: matchesHighlighting,
        withLinks: wikipediaLinks,
        columnEventType: columnEventType,
        columnActCode: columnActCode
      }), /*#__PURE__*/_jsx(SmallPagination, {
        currentPage: form.currentPage,
        totalPages: totalPages,
        onChange: handlePageChange,
        disabled: loading
      })]
    }) : /*#__PURE__*/_jsxs("div", {
      className: "text-center mt-2",
      children: [/*#__PURE__*/_jsx("h5", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "result.no_result.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "text-muted",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "result.no_result.description"
        })
      })]
    })]
  });
}